export const MODULE_NAME = 'Subscription'

export const paths = {
  root: '/subscription',
  payment: '/subscription/payment',
  summary: '/subscription/summary',
}
